import { useMutation, useQuery } from '@apollo/client';
import partition from 'lodash/partition';
import { useMemo } from 'react';

import {
  deleteDocumentReferenceTemplateMutation,
  getDocumentReferenceTemplatesQuery,
} from '../documents.operations';

export const useDocumentTemplates = () => {
  const { data, loading, refetch } = useQuery(
    getDocumentReferenceTemplatesQuery,
  );
  const templates = data?.documentReferenceTemplates ?? [];

  const { createdByYou, createdByEluve } = useMemo(() => {
    const [createdByEluve, createdByYou] = partition(
      templates,
      (t) => t.isSystemDefault,
    );
    return { createdByYou, createdByEluve };
  }, [templates]);

  const [deleteTemplate] = useMutation(deleteDocumentReferenceTemplateMutation);

  return {
    templates,
    createdByYou,
    createdByEluve,
    loading,
    hasData: Boolean(data),
    refetch,
    deleteTemplate,
  };
};

export type DocumentTemplate = ReturnType<
  typeof useDocumentTemplates
>['templates'][number];
